import React from "react";
import { DesktopPortal } from "./DesktopPortal";
import { useWinStore } from "./windowStore";

export const Taskbar: React.FC = () => {
  const windows = useWinStore((s) => s.windows);
  const { focus, restore, close } = useWinStore((s) => s);
  const minimized = windows.filter((w) => w.minimized);

  if (!minimized.length) return null;

  return (
    <DesktopPortal>
      <div
        style={{
          position: "fixed",
          left: 0,
          right: 0,
          bottom: 0,
          height: 44,
          backdropFilter: "blur(1px)",
          background: "rgba(250, 250, 250, 0)",
          // borderTop: "1px solid rgba(125, 122, 122, 0.46)",
          display: "flex",
          alignItems: "center",
          gap: 8,
          padding: "0 10px",
          zIndex: 1001
        }}
      >
        {minimized.map((w) => {
          const isWhatsApp = w.identifier?.startsWith("whatsapp-");
          const hasMetadata = w.metadata?.name || w.metadata?.phone;

          // Si es WhatsApp y tiene metadata, mostrar layout personalizado
          if (isWhatsApp && hasMetadata) {
            return (
              <div
                key={w.id}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  maxHeight: 60,
                  minHeight: 45,
                  padding: "0 16px",
                  borderRadius: "8px 8px 0 0",
                  background: "rgba(31, 43, 69, 1)",
                  border: "1px solid #0076b6",
                  color: "#fff",
                  cursor: "default",
                  whiteSpace: "nowrap"
                }}
                onClick={(e) => {
                  // Prevenir que el click en los botones propague
                  if ((e.target as HTMLElement).closest(".taskbar-button")) {
                    return;
                  }
                  restore(w.id);
                  focus(w.id);
                }}
              >
                {/* Primera columna: Nombre y teléfono */}
                <div
                  style={{
                    flex: 1,
                    minWidth: 0,
                    display: "flex",
                    flexDirection: "column",
                    gap: 2
                  }}
                >
                  <div
                    style={{
                      fontWeight: "bold",
                      fontSize: "13px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap"
                    }}
                  >
                    {w.metadata?.name || "—"}
                  </div>
                  <div
                    style={{
                      fontSize: "11px",
                      opacity: 0.8,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap"
                    }}
                  >
                    {w.metadata?.phone || "—"}
                  </div>
                </div>

                {/* Columna derecha: Botones */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 6,
                    marginLeft: 8
                  }}
                >
                  <button
                    className="taskbar-button"
                    onClick={(e) => {
                      e.stopPropagation();
                      restore(w.id);
                      focus(w.id);
                    }}
                    style={{
                      background: "transparent",
                      border: "none",
                      color: "#fff",
                      cursor: "pointer",
                      padding: "4px 6px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "20px"
                    }}
                    title="Restaurar ventana"
                  >
                    <i className="fas fa-window-restore" />
                  </button>
                  <button
                    className="taskbar-button"
                    onClick={(e) => {
                      e.stopPropagation();
                      close(w.id);
                    }}
                    style={{
                      background: "transparent",
                      border: "none",
                      color: "#fff",
                      cursor: "pointer",
                      padding: "0",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "20px"
                    }}
                    title="Cerrar ventana"
                  >
                    <i className="fas fa-window-close" />
                  </button>
                </div>
              </div>
            );
          }

          // Layout por defecto para otras ventanas
          return (
            <button
              key={w.id}
              onClick={() => {
                restore(w.id);
                focus(w.id);
              }}
              style={{
                maxHeight: 60,
                minHeight: 40,
                padding: "0 12px",
                borderRadius: 8,
                background: "rgba(31, 43, 69, 1)",
                border: "1px solid #0076b6",
                color: "#fff",
                fontWeight: "bold",
                cursor: "pointer",
                whiteSpace: "nowrap"
              }}
              title={`Restaurar "${w.title}"`}
            >
              {w.title}
            </button>
          );
        })}

        <div style={{ marginLeft: "auto" }}></div>
      </div>
    </DesktopPortal>
  );
};
